import { useContext, useEffect, useState } from "react";
import { Context } from "Context";
import SmartBanner from "./SmartBanner";
import MessageCenter from "../message-center/MessageCenter";
import TravelAgentHeader from "../travel-agent-header/TravelAgentHeader";
import Navigation from "./navigation/Navigation";
import MessageBanner from "./MessageBanner";
import useFetch from "hooks/useFetch";
import appConfig from "config.json";
import Loading from "components/shared/Loading";
import { mapString, isTravelAgent } from "utils";
import { getCurrentDateInSelectedLocale } from "utils/date";
import Banner from "./banner/Banner";
import { filterContentByUserType } from "utils/filterContent";

const { brands, defaultParkHoursTimeZone, content } = appConfig;
const cacheMinutes = 5;
const mainClass = "syndicated-header";

const Header = () => {
	const {
		config,
		headerData,
		setHeaderData,
		setConfig,
		profileData: { userType, user },
	} = useContext(Context);

	const [headerUrl, setHeaderUrl] = useState("");
	const brandConfig = brands?.[config.brand];

	const parkHoursTimeZone =
		brandConfig?.defaultParkHoursTimeZone || defaultParkHoursTimeZone;
	const isUserTypeRequired = brandConfig?.isUserTypeRequiredForContentRequest;
	const { response, error } = useFetch(headerUrl, {}, cacheMinutes, headerUrl);

	let classes = `${mainClass} ${mainClass}--${config.brand} ${mainClass}--${config.locale}`;
	if (config.position) {
		classes += ` ${mainClass}--${config.position}`;
		if (config.position === "sticky") {
			const parentDiv = document.querySelector(".syndicated-header-parent");
			parentDiv.classList.add("syndicated-header-parent--sticky");
		}
	}

	if (config.store) {
		classes += ` ${mainClass}__store ${mainClass}__store--${config.store}`;
	}

	if (config.theme) {
		classes += ` syndicated-theme--${config.theme}`;
	}

	useEffect(() => {
		if (!isUserTypeRequired || (isUserTypeRequired && userType)) {
			const headerBaseUrl = mapString(
				content.apiUrl.header,
				getCurrentDateInSelectedLocale(parkHoursTimeZone, "ISO", "en-us")
			);
			setHeaderUrl(
				isUserTypeRequired && userType
					? `${headerBaseUrl}&userType=${userType}`
					: headerBaseUrl
			);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [userType, config.brand]);

	useEffect(() => {
		if (response) {
			if (brandConfig.filterContentKeys) {
				setHeaderData(
					filterContentByUserType(response, brandConfig.filterContentKeys, user)
				);
			} else {
				setHeaderData(response);
			}
			setConfig((config) => ({
				...config,
				...(response.context || {}),
			}));
		} else if (error) {
			setHeaderData({ error: true, loading: false });
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [error, response]);

	useEffect(() => {
		if (brandConfig.filterContentKeys && response) {
			setHeaderData(
				filterContentByUserType(response, brandConfig.filterContentKeys, user)
			);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [user?.swid, user?.membership]);

	return (
		<div className={classes} style={{ visibility: "hidden" }}>
			{config.smartBanner && <SmartBanner />}
			{config.banner && <Banner />}
			{config.travelAgentHeader &&
				(config.store || (isUserTypeRequired && isTravelAgent(userType))) && (
					<TravelAgentHeader />
				)}
			{config.messageCenter && !document.getElementById("messageCenter") && (
				<MessageCenter />
			)}
			{headerData.loading && <Loading brand={config.brand} />}
			{!config.hideFullNavigation &&
				!headerData.loading &&
				!headerData.error && (
					<Navigation showLogo={!config.navigation && !config.chrome} />
				)}
			{config.messageBanner && <MessageBanner />}
			<div id="pageContentStart" tabIndex={-1} />
		</div>
	);
};

export default Header;
